import { type DataItem, Text, HtmlCheckbox } from "@ttc3k/trekker";
import { Flex } from "styled-system/jsx";

type ChecklistProps = {
  value: string[];
  onValueChange: (value: string[]) => void;
  data: DataItem[];
};

export const Checklist = ({ data, onValueChange, value }: ChecklistProps) => {
  const handleItemSelect = (val: string, isAdding: boolean) => {
    if (isAdding) {
      onValueChange([...value, val]);
    } else {
      onValueChange(value.filter((id) => id !== val));
    }
  };
  return (
    <Flex flexDir={"column"} gap={"150"}>
      {data.map((item) => (
        <Text
          key={item.value}
          as={"label"}
          visual={"bodyMedium"}
          display={"flex"}
          gap={"150"}
          alignItems={"center"}
          color={item.disabled ? "text.disabled" : "text.mid"}
          cursor={item.disabled ? "not-allowed" : "pointer"}
        >
          <HtmlCheckbox
            name={item.value}
            id={item.value}
            onChange={(e) => handleItemSelect(item.value, e.target.checked)}
            checked={!!value.find((id) => id === item.value)}
            disabled={item.disabled}
          />
          {item.label}
        </Text>
      ))}
    </Flex>
  );
};
